import * as React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BuildingComplex, Info, MessagesSquare, Plus, SlidersHorizontal } from "lucide-react";
import { CatalogCta, CatalogLayout, SolutionCards } from "../components/catalog";
import { useContactModal } from "../context/contactModal";
import { getProduct } from "../data/products";
export const HERO_PRODUCTS = ["atlas-a7", "thor-duo", "fmg-imu"];
export function HomeHero() {
  const [e, t] = React.useState(HERO_PRODUCTS[0]);
  const [n, r] = React.useState(false);
  const [i, o] = React.useState(false);
  const s = React.useRef(null);
  const l = React.useRef(null);
  const c = getProduct(e);
  const { openInquiry } = useContactModal();
  const f = (d) => (d === "fmg-imu" ? "/assets/catalog/fmg-hero-cutout.webp" : getProduct(d).image);
  React.useEffect(() => {
    const d = (g) => {
      var x;
      var w;
      if (g.key === "Escape") {
        r(false);
        o(false);
        if ((x = s.current) != null && x.contains(document.activeElement)) {
          if ((w = l.current) != null) {
            w.focus();
          }
        }
      }
    };
    const h = (g) => {
      var x;
      if ((x = s.current) == null || !x.contains(g.target)) {
        o(false);
      }
    };
    document.addEventListener("keydown", d);
    document.addEventListener("pointerdown", h);
    return () => {
      document.removeEventListener("keydown", d);
      document.removeEventListener("pointerdown", h);
    };
  }, []);
  return (
    <section className="showroom industrial-showroom compact-showroom">
      <div className="catalog-wrap">
        <div
          className={`hero-product-main ${n ? "is-revealed" : ""}`}
          onMouseLeave={() => r(false)}
          onBlur={(d) => {
            if (!d.currentTarget.contains(d.relatedTarget)) {
              r(false);
            }
          }}
        >
          <Link
            onMouseEnter={() => r(true)}
            onFocus={() => r(true)}
            className="hero-product-image"
            to={`/products/${c.slug}`}
            aria-label={`View ${c.name}`}
          >
            <h1 className="hero-background-slogan">
              Hardware for
              <br />
              robot learning.
            </h1>
            <img
              className="showroom-reveal"
              src={f(c.slug)}
              alt={`${c.name} concept reference`}
              key={c.slug}
            />
          </Link>
          <div className="hero-product-info" id="featured-product-info" aria-hidden={!n}>
            <article className="hero-info-card hero-identity">
              <p className="catalog-kicker">{c.category}</p>
              <h2>{c.name}</h2>
              <p>{c.subtitle}</p>
            </article>
            {c.metrics.slice(0, 3).map(([d, h], g) => (
              <dl className={`hero-info-card hero-metric hero-metric-${g}`} key={h}>
                <dt>{h}</dt>
                <dd>{d}</dd>
              </dl>
            ))}
          </div>
          <div className="hero-product-controls">
            <div className="hero-mini-switch" role="group" aria-label="Featured products">
              {HERO_PRODUCTS.map((d) => (
                <button
                  title={getProduct(d).name}
                  aria-label={getProduct(d).name}
                  aria-pressed={e === d}
                  onClick={() => {
                    t(d);
                    r(false);
                    o(false);
                  }}
                  key={d}
                >
                  <span aria-hidden="true" />
                </button>
              ))}
            </div>
            <button
              className="hero-info-toggle"
              title="Specifications"
              aria-label="Specifications"
              aria-expanded={n}
              aria-controls="featured-product-info"
              onClick={() => r(!n)}
            >
              <Info size={22} />
            </button>
            <div
              ref={s}
              className={`hero-action-disclosure ${i ? "is-open" : ""}`}
              onMouseEnter={() => {
                if (matchMedia("(hover: hover)").matches) {
                  o(true);
                }
              }}
              onMouseLeave={() => o(false)}
              onFocus={(d) => {
                if (d.target.matches(":focus-visible")) {
                  o(true);
                }
              }}
              onBlur={(d) => {
                if (!d.currentTarget.contains(d.relatedTarget)) {
                  o(false);
                }
              }}
            >
              <button
                ref={l}
                className="hero-action-toggle"
                title={i ? "Close product actions" : "Product actions"}
                aria-label={i ? "Close product actions" : "Product actions"}
                aria-expanded={i}
                aria-controls="hero-product-actions"
                onClick={() => o(!i)}
              >
                <Plus size={28} aria-hidden="true" />
              </button>
              <div id="hero-product-actions" className="hero-action-panel" aria-hidden={!i}>
                <Link tabIndex={i ? 0 : -1} className="catalog-button" to={`/products/${c.slug}`}>
                  View Details <ArrowRight size={18} />
                </Link>
                <button
                  tabIndex={i ? 0 : -1}
                  className="catalog-button catalog-button-outline"
                  onClick={() => {
                    o(false);
                    openInquiry(c.name);
                  }}
                >
                  Request a Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export function HomeCategories() {
  return (
    <section className="catalog-wrap catalog-section showroom-categories">
      <div className="catalog-section-head">
        <div>
          <p className="catalog-kicker">Find your hardware</p>
          <h2>Explore by category.</h2>
        </div>
        <Link className="catalog-text-link" to="/products">
          All products <ArrowRight size={18} />
        </Link>
      </div>
      <div className="category-grid">
        {[
          ["Ego capture", "Visual-inertial recording", "thor-quad", "/products/thor-ego"],
          ["Hand & forearm sensing", "Contact and motion signals", "fmg-imu", "/products/fmg-imu"],
          ["Manipulators", "Robot learning workstations", "atlas-a7", "/products/atlas-a7"],
          ["Integrated robotics", "Desktop and mobile platforms", "atlas-m", "/products/atlas-m"],
        ].map(([e, t, n, r]) => (
          <Link to={r} key={e}>
            <img
              src={
                n === "thor-quad"
                  ? "/assets/catalog/thor-device-category-v1.webp"
                  : n === "fmg-imu"
                    ? "/assets/catalog/fmg-device-category-v1.webp"
                    : getProduct(n).image
              }
              alt=""
              loading="lazy"
            />
            <h3>{e}</h3>
            <p>{t}</p>
            <ArrowRight size={20} />
          </Link>
        ))}
      </div>
    </section>
  );
}
export function HomeTrust() {
  return (
    <section className="inquiry-trust">
      <div className="catalog-wrap">
        {[
          {
            Icon: BuildingComplex,
            title: "U.S.-based company",
            text: "Operated by Impact Frontiers Inc., New York.",
          },
          {
            Icon: SlidersHorizontal,
            title: "Project-specific configuration",
            text: "Agree on hardware, interfaces and delivery scope.",
          },
          {
            Icon: MessagesSquare,
            title: "Discuss your requirements",
            text: "Talk through integration and evaluation with our team.",
          },
        ].map(({ Icon, title, text }) => (
          <div key={title}>
            <Icon size={24} />
            <div>
              <h3>{title}</h3>
              <p>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
export function HomePage() {
  return (
    <CatalogLayout title="Robot Learning & Data Infrastructure">
      <HomeHero />
      <HomeCategories />
      <section className="catalog-wrap catalog-section">
        <p className="catalog-kicker">Applications</p>
        <h2>Start with the task.</h2>
        <p className="catalog-section-intro">
          Find a setup for data collection, robot learning or multimodal research.
        </p>
        <SolutionCards />
        <p className="catalog-note">
          Need GPU compute, model training or hosted inference for your robots?{" "}
          <Link className="catalog-text-link" to="/training">
            Training & Compute →
          </Link>
        </p>
      </section>
      <HomeTrust />
      <CatalogCta />
    </CatalogLayout>
  );
}
